import { Page, Card, BlockStack, SkeletonTabs, Box } from '@shopify/polaris';
import React from 'react';
import { AttributeSkeleton, CategorySkeleton, FilterSkelton, FullfillmentSkeleton, InventorySkeleton, PriceSkeleton, ProductSkeleton, SmallSkeleton } from './Skeleton';
import { DI, DIProps } from '../../../../../../Core';
import { useTranslation } from "react-i18next";

interface Props extends DIProps {
    templateId: string;
    type: string;
    syncNecessaryInfo: () => void;
    syncConnectorInfo: () => void;
    getTemplateDescription: () => string;
    getTemplateTitle: () => string;
}
const TemplateSkeleton = (props: Props) => {
    const { t } = useTranslation();
    return (
        <Page
            backAction={
                {
                    content: t("Template"),
                    onAction: () => {
                        props.history("../config")
                    },
                }
            }

            subtitle={props?.getTemplateDescription()}
            title={props?.getTemplateTitle()}
        >
            <div className='has-sticky-annotated' >
                <BlockStack gap={"400"}>
                    <BlockStack gap={"600"}>
                        <div className='ml-32'>
                            <Box minHeight="80px" background="bg-fill-disabled"></Box>
                        </div>
                        <Card padding={"025"}>
                            <SkeletonTabs count={6} />
                        </Card>
                    </BlockStack>
                    <SmallSkeleton type={props?.type} t={t} />
                    <FullfillmentSkeleton type={props?.type} t={t} />
                    <CategorySkeleton type={props?.type} t={t} />
                    <AttributeSkeleton type={props?.type} t={t} />
                    <InventorySkeleton t={t} />
                    <PriceSkeleton t={t} />
                    <ProductSkeleton t={t} />
                    <FilterSkelton type={props?.type} t={t} />
                </BlockStack>
            </div>
        </Page>
    );
}

export default DI(TemplateSkeleton);